import { useRouter } from 'next/router';
import { ContainerBase } from '@/components/landing/containers';
import { Button, Typography } from '../../common';
import Icons from '@/const/icons';

interface BannerProps {
	withBackButton?: boolean;
}

export const Banner: React.FC<BannerProps> = ({ withBackButton }) => {
	const router = useRouter();
	return (
		<ContainerBase className="h-[202px]">
			<div
				className={`
					absolute inset-0 rounded-[64px] bg-no-repeat
					bg-[url('/img/landing/svg/bubbles-general-banner-mobile.svg')] bg-top bg-contain
					lg:bg-[url('/img/landing/svg/bubbles-general-banner.svg')] lg:bg-[position:120px_-40px] lg:bg-auto`}
			/>

			<div className="relative flex justify-center pt-[100px] h-full z-10">
				{withBackButton && (
					<Button
						label="Back"
						size="fit"
						icon={Icons.arrowLeft}
						iconLeft
						className="border-none !p-0 !w-auto absolute top-10 md:top-10 left-0"
						classNameLabel="!text-[18px]"
						classNameButton="!mr-4"
						onClick={() => {
							if (router.pathname.includes('clientapp/all-cases')) {
								router.back();
							} else {
								router.push('/');
							}
						}}
					/>
				)}
				<div className="flex flex-col items-center justify-center">
					<Typography type="headline-2" className="text-center">
						Find Your Claim
						<br className="block md:hidden" /> Today
					</Typography>
					<Typography type="regular-20">
						See if You Qualify in Less than 5 minutes
					</Typography>
				</div>
			</div>
		</ContainerBase>
	);
};
